import React from 'react'

interface Props {
  voidedCount: number
  isCollapsed: boolean
  onToggle: () => void
}

export const VoidedSummaryRow: React.FunctionComponent<Props> = (props) => {
  const { voidedCount, isCollapsed, onToggle } = props
  return (
    <tr className="voided-summary-row">
      <td colSpan={5}>
        {voidedCount} voided invoice{voidedCount === 1 ? '' : 's'}{' '}
        {isCollapsed ? 'hidden' : 'shown'}{' '}
        <button
          type="button"
          className="vsr-toggle"
          onClick={(event) => {
            event.stopPropagation()
            onToggle()
          }}
          style={{
            background: 'transparent',
            border: 'none',
            padding: 0,
            font: 'inherit',
          }}
        >
          {isCollapsed ? 'View voided' : 'Hide voided'}
        </button>
      </td>
    </tr>
  )
}
